/*
 * @Description: 
 */
/*
 * @Description: 
 */
// src/utils/localStorageUtil.js

export const saveToLocal = (key, data) => {
    let tempPath = window.Application.Env.GetHomePath()
    let filePath = tempPath + "/" + key + '.txt'
    console.log(key, data, filePath)
    if (data) {
        window.Application.FileSystem.WriteFile(filePath, JSON.stringify(data))
    } else {
        removeFromLocal(key, data)
    }
};

export const getFromLocal = (key) => {
    try {
        let tempPath = window.Application.Env.GetHomePath()
        let filePath = tempPath + "/" + key + '.txt'
        if (window.Application.FileSystem.Exists(filePath)) {
            const data = window.Application.FileSystem.ReadFile(filePath);
            return data ? JSON.parse(data) : undefined;
        }
        return undefined
    } catch (error) {
        this.removeFromLocal(key)
        return undefined
    }

};

export const removeFromLocal = (key) => {
    let tempPath = window.Application.Env.GetHomePath()
    let filePath = tempPath + "/" + key + '.txt'
    if (window.Application.FileSystem.Exists(filePath)) {
        window.Application.FileSystem.Remove(filePath);
    }
};